import React, { useState } from "react";
import { motion } from "framer-motion";

const PROMO_IMG = "https://customer-assets.emergentagent.com/job_exfoliating-bars/artifacts/oegeg215_file_000000003fd4720cb8edc72ff4dfc76e.png";

export default function PromoBanner({ onOpenCart }) {
  const [dismissed, setDismissed] = useState(false);

  if (dismissed) return null;

  const handleClick = () => {
    if (onOpenCart) onOpenCart();
  };

  return (
    <motion.section
      initial={{ opacity: 0, y: 20 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.6 }}
      className="py-12 lg:py-16 cursor-pointer"
      onClick={handleClick}
      data-testid="promo-banner-section"
    >
      <div className="max-w-3xl mx-auto px-6 lg:px-8">
        <div className="relative overflow-hidden border" style={{ borderColor: '#FF5A36' }}>
          <img
            src={PROMO_IMG}
            alt="Limited Time Sale — Buy One Get One Free — Use code TRYBOTH at checkout — $8 shipped free"
            className="w-full object-contain"
            data-testid="promo-banner-image"
          />
        </div>
        <p
          className="text-center mt-4 font-accent text-sm tracking-wide"
          style={{ color: '#9A9A9A' }}
        >
          Tap to open cart and enter code <span style={{ color: '#FF5A36' }} className="font-bold">TRYBOTH</span> at checkout
        </p>
      </div>
    </motion.section>
  );
}
